module.exports = __webpack_public_path__ + "img/AGR-i-2-III.98e2b8fa.png";